<template>
  <div class="main-panel">
    <top-navbar />
    <main-content></main-content>
    <content-footer></content-footer>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MainContent from "./Content.vue";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    MainContent
  }
};
</script>
<style>
.main-panel {
  background: white;
}
.message-box {
  width: 75% !important;
  font-family: "Montserrat";
  font-style: normal !important;
  font-weight: 700 !important;
  font-display: swap !important;
  color: #026A89 !important;
}
.message-box-confirm-button {
  background: #FF3333 !important;
  color: white !important;
  border: #FF3333 !important;
  font-family: "Montserrat";
}
.message-box-cancel-button {
  background: #007A9C !important;
  color: white !important;
  border: #007A9C !important;
  font-family: "Montserrat";
}
.button{
  font-family: "Montserrat";
  font-weight: 700;
  background: #007A9C;
  color: white;
  width: 80%;
  margin: auto !important;
  margin-bottom: 5px !important;
  display: block;
  margin-top: 5px !important;
}
</style>
